import styled from "styled-components";
import { Link } from "react-router-dom";

export const SiteWrapperLink = styled(Link)`
    color: #000;

    &:hover {
        color: #000;
        text-decoration: underline;
    }
`;
